<template>
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h5 class="mb-0">Datos sobre entidad pagadora</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <label for="payment_center_id">
              Centro que incurre en el gasto <span class="text-danger">*</span>
            </label>
            <select
              :value="localResume.payment_center_id"
              @change="updateField('payment_center_id', parseSelectValue($event.target.value))"
              @blur="v.payment_center_id && v.payment_center_id.$touch()"
              class="form-control"
              :class="{ 'is-invalid': v.payment_center_id && v.payment_center_id.$error }"
              id="payment_center_id"
              :disabled="loadingCenters"
              required
            >
              <option :value="null">Seleccione un centro</option>
              <option
                v-for="option in selectOptionsCenters"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <div v-if="v.payment_center_id && v.payment_center_id.$error" class="invalid-feedback">
              <div v-if="!v.payment_center_id.required">{{ errorMessages.required }}</div>
            </div>
            <small v-if="selectOptionsCenters.length === 0 && !loadingCenters" class="text-muted">
              No hay centros disponibles para este ensayo
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api-rest/api.js";
import { errorMessages } from "@/helpers/validations/errorMessages";
import { autoSelectMixin } from "@/helpers/mixins/autoSelectMixin";

export default {
  name: "PayerEntitySection",
  mixins: [autoSelectMixin],
  props: {
    localResume: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
    essay_id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      errorMessages,
      selectOptionsCenters: [],
      loadingCenters: false,
      // Auto-select configuration
      autoSelectConfig: {
        payment_center_id: {
          options: () => this.selectOptionsCenters,
          enabled: true,
          skipIfValueExists: true,
        },
      },
    };
  },
  mounted() {
    this.setupAutoSelect();
  },
  methods: {
    parseSelectValue(value) {
      if (!value || value === "" || value === "null" || value === "undefined") {
        return null;
      }
      const parsed = Number.parseInt(value, 10);
      return Number.isNaN(parsed) ? null : parsed;
    },
    updateField(field, value) {
      // Reset auto-select tracking when user manually changes value
      this.resetAutoSelect(field);
      this.$emit("update:field", field, value);
    },
    async loadCenters() {
      if (!this.essay_id) {
        this.selectOptionsCenters = [];
        return;
      }
      
      this.loadingCenters = true;
      try {
        const apiEndpoint = `/api/v1/essay/${this.essay_id}/centers`;
        const response = await api.get({ url: apiEndpoint });
        const centers = response?.data?.data || [];
        
        this.selectOptionsCenters = centers.map((center) => ({
          value: center.id,
          text: center.name || center.center_code || `Centro ${center.id}`,
        }));
      } catch (error) {
        console.error("Error loading centers:", error);
        this.selectOptionsCenters = [];
        if (this.$bvToast) {
          this.$bvToast.toast("Error al cargar los centros", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      } finally {
        this.loadingCenters = false;
      }
    },
  },
  watch: {
    essay_id: {
      immediate: true,
      handler() {
        this.loadCenters();
      },
    },
  },
};
</script>
